import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/leaf-with-shadow.png'
import _imports_1 from '@/assets/icons/rocket_500.png'
import _imports_2 from '@/assets/icons/leafy_tree_180.png'
import _imports_3 from '@/assets/icons/pawn_150.png'
import _imports_4 from '@/assets/icons/sparkle_60.png'
import _imports_5 from '@/assets/icons/highlights_200.png'


const _withScopeId = n => (_pushScopeId("data-v-0d7960dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-home-page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "page-content container-lg"
}
const _hoisted_4 = { class: "title-area container-lg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Welcome to Tree Crossing!"),
  /*#__PURE__*/_createElementVNode("div", null, "You're signed in and ready to start.")
], -1))
const _hoisted_7 = { class: "start-actions" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Upload my tree", -1))
const _hoisted_10 = {
  key: 2,
  class: "page-content container-lg"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-area" }, [
  /*#__PURE__*/_createElementVNode("h2", null, " Start exploring your family ")
], -1))
const _hoisted_12 = { class: "alerts" }
const _hoisted_13 = {
  key: 0,
  class: "alert alert-success alert-dismissible"
}
const _hoisted_14 = { class: "activity-row" }
const _hoisted_15 = { class: "explore-family" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Explore my family", -1))
const _hoisted_18 = { class: "explore-names" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Explore names", -1))
const _hoisted_20 = { class: "explore-places" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Explore places", -1))
const _hoisted_22 = { class: "activity-row" }
const _hoisted_23 = { class: "games" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Games", -1))
const _hoisted_26 = { class: "news" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "What's new", -1))
const _hoisted_29 = { class: "explore-time" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Dates", -1))
const _hoisted_31 = { class: "highlights" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Highlights", -1))
const _hoisted_34 = { class: "other-actions" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, " Things to do ", -1))
const _hoisted_36 = { class: "list-unstyled" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "link-dark disabled"
  }, " Create child accounts ")
], -1))

import { computed, onMounted, ref } from 'vue'
import { usePageTitle } from '@/util/AppUtil'
import { useUserStore } from "@/gp/UserStore"
import { useDataGroupStore } from "@/gp/DataGroupStore"
import { useFamilyGroupMemberStore } from '@/gp/FamilyGroupMemberStore'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { User } from '@/gp/GroupAdminModel'
import { useTokenManager } from '@/auth/TokenManager'
import { LoadMode } from '@/util/AsyncData'
import { useExploreStore } from './ExploreStore'
import { useUploadAction } from '@/site/UploadAction'
import { DateTime } from 'luxon'
import { ViewPerson } from '@/rd/ResearchDataModel'
import { useFeatureStore, SyncChangesFeature } from '@/rd/FeatureStore'
import LoadingIndicator from '@/util/LoadingIndicator.vue'
import UserNameConfirmModal from "@/manage/users/UserNameConfirmModal.vue"
import ScopeLoadProgress from './ScopeLoadProgress.vue'
import { useViewScopeStore } from './ViewScopeStore'
import NameCloud from './names/NameCloud.vue'
import CountryCloud from './places/CountryCloud.vue'
import CalendarIcon from './time/CalendarIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserHomePage',
  setup(__props) {

const selfUserRef = ref<User>()

const userStore = useUserStore()
const dataGroupStore = useDataGroupStore()
const exploreStore = useExploreStore()
const familyGroupMemberStore = useFamilyGroupMemberStore()
const familyGroupStore = useFamilyGroupStore()
const tokenManager = useTokenManager()

const { showUploadActionRef } = useUploadAction()
const featureStore = useFeatureStore()
const syncChangesEnabledRef = computed(() => featureStore.isFeatureEnabled(SyncChangesFeature))

const viewScopeStore = useViewScopeStore()
const scopeLoading = computed(() => !viewScopeStore.getAsyncScopeInfo(exploreStore.startPersonId, LoadMode.EnsureLoaded)?.isLoaded)

const loadingRef = computed(() => showUploadActionRef.value === undefined)
const selfProfileRef = computed(() => dataGroupStore.getAsyncGroup(selfUserRef.value?.profileDataGroupId, LoadMode.EnsureLoaded)?.data)
const recentJoinedFamilyGroupRef = computed(() => {
  const allMem = familyGroupMemberStore.getMembersForUsers(undefined, LoadMode.EnsureLoaded)
  const recentMem = allMem.filter(m => DateTime.utc().diff(m.createdDate!, 'days').days < 1)
    .filter(m => !m.isOwner)
    .sort((a, b) => b.createdDate!.valueOf() - a.createdDate!.valueOf())
    .at(0)
  if (recentMem && !exploreStore.dismissedJoinedGroupIds.includes(recentMem.id!)) {
    return familyGroupStore.getGroupList([recentMem.familyGroupId!]).at(0)
  }
  return undefined
})
const exploreFamilyUrlRef = computed(() => {
  if (selfProfileRef.value) {
    return ViewPerson.getPageUrl(selfProfileRef.value.startItemId!)
  }
  return undefined
})

usePageTitle("Home")

const userNameConfirmModalRef = ref<InstanceType<typeof UserNameConfirmModal>>()

onMounted(async () => {
  selfUserRef.value = await userStore.getAsyncSelf()?.whenLoadCompleted
  if (selfUserRef.value && !tokenManager.current.isSupervised && !selfUserRef.value.metadata?.nameConfirmed) {
    userNameConfirmModalRef.value?.open()
  }
})

function dismissJoinedFamilyGroupAlert() {
  exploreStore.dismissedJoinedGroupIds.push(recentJoinedFamilyGroupRef.value!.id!)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loadingRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LoadingIndicator)
        ]))
      : (_unref(showUploadActionRef))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", null, [
                _hoisted_5,
                _createTextVNode(" Hi, " + _toDisplayString(selfUserRef.value?.givenName) + "! ", 1)
              ]),
              _hoisted_6
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: syncChangesEnabledRef.value ? '/trees/new' : '/syncapp',
                class: "btn btn-choice"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  class: "btn btn-link",
                  to: "/start/family"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" I want to create a family tree ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  class: "btn btn-link",
                  to: "/start/family"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" I want someone to share their tree with me ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            (scopeLoading.value)
              ? (_openBlock(), _createBlock(ScopeLoadProgress, { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_12, [
                    (recentJoinedFamilyGroupRef.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", null, " Welcome to " + _toDisplayString(recentJoinedFamilyGroupRef.value.name) + "! ", 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "alert",
                            "aria-label": "Close",
                            onClick: dismissJoinedFamilyGroupAlert
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_router_link, {
                          class: _normalizeClass(["btn btn-choice", { disabled: !_unref(exploreStore).enableExploreRef }]),
                          to: exploreFamilyUrlRef.value ?? ''
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }, 8, ["class", "to"]),
                        _hoisted_17
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_router_link, { to: "/names" }, {
                          default: _withCtx(() => [
                            _createVNode(NameCloud, {
                              width: 200,
                              height: 120
                            })
                          ]),
                          _: 1
                        }),
                        _hoisted_19
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_router_link, { to: "/places" }, {
                          default: _withCtx(() => [
                            _createVNode(CountryCloud)
                          ]),
                          _: 1
                        }),
                        _hoisted_21
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_router_link, { to: "/games" }, {
                          default: _withCtx(() => [
                            _hoisted_24
                          ]),
                          _: 1
                        }),
                        _hoisted_25
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_router_link, { to: "/news" }, {
                          default: _withCtx(() => [
                            _hoisted_27
                          ]),
                          _: 1
                        }),
                        _hoisted_28
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_router_link, { to: "/time" }, {
                          default: _withCtx(() => [
                            _createVNode(CalendarIcon)
                          ]),
                          _: 1
                        }),
                        _hoisted_30
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_router_link, { to: "/highlights" }, {
                          default: _withCtx(() => [
                            _hoisted_32
                          ]),
                          _: 1
                        }),
                        _hoisted_33
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("ul", _hoisted_36, [
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          class: "link-dark",
                          to: "/trees"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Manage my trees ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          class: "link-dark",
                          to: "/profile"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Update my profile ")
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_37,
                      _createElementVNode("li", null, [
                        _createVNode(_component_router_link, {
                          class: "link-dark",
                          to: "/groups"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Invite family ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ])
                ], 64))
          ])),
    _createVNode(UserNameConfirmModal, {
      ref_key: "userNameConfirmModalRef",
      ref: userNameConfirmModalRef
    }, null, 512)
  ]))
}
}

})